var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit011(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-01 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.7102 6.58751C27.6018 7.238 27.2146 7.71296 26.7732 8.17243C23.1593 11.9291 19.5558 15.6901 15.9626 19.4553C15.9086 19.5254 15.8603 19.5996 15.8181 19.6773C15.1676 17.8704 14.0318 16.6753 12.1475 16.1255C12.2439 16.068 12.337 16.0051 12.4262 15.937L23.9828 4.90449C24.7881 4.1301 25.7432 3.99071 26.6518 4.50697C26.911 4.65362 27.1354 4.85458 27.3096 5.09607C27.4838 5.33755 27.6037 5.61386 27.6611 5.90604C27.6766 5.96799 27.6947 6.02995 27.7102 6.0919V6.58751Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.35931 23.1415C3.03561 22.8833 3.7274 22.6613 4.38047 22.3671C5.34588 21.9205 6.00928 21.1358 6.57975 20.2607C6.8926 19.7284 7.26782 19.2354 7.69746 18.7919C8.87712 17.6923 10.2788 17.2225 11.8869 17.6252C13.1363 17.9401 13.9287 18.8023 14.3392 19.9948C15.0258 22.0031 14.2308 24.0243 12.3464 25.1368C10.9389 25.9446 9.31565 26.2963 7.70004 26.1435C6.45994 26.076 5.25226 25.7226 4.17139 25.111C3.39027 24.7032 2.76656 24.0477 2.39803 23.2473C2.39803 23.2266 2.36705 23.2111 2.35156 23.1931L2.35931 23.1415Z",
    fill: "#999999"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit011);
export default __webpack_public_path__ + "static/media/edit-01 1.4ee1aced3d0a9d2fc35cbfb7bb0e6ee1.svg";
export { ForwardRef as ReactComponent };